import React, { useState, useEffect } from 'react';
import '../assets/css/imageCarousel.css';

const ImageCarousel = () => {
  const [images, setImages] = useState([]);
  const [texts, setTexts] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch images list - try JSON first (for localhost), then PHP (for server)
    const fetchImages = async () => {
      try {
        // Try JSON file first (works in development/localhost)
        let response = await fetch('/Home/images.json');
        let data = null;
        
        if (response.ok) {
          const text = await response.text();
          // Check if it's valid JSON or PHP code
          if (text.trim().startsWith('<?php') || text.trim().startsWith('<!')) {
            // This shouldn't happen with JSON, but if it does, try PHP
            response = await fetch('/Home/images.php');
            if (response.ok) {
              const phpText = await response.text();
              if (!phpText.trim().startsWith('<?php') && !phpText.trim().startsWith('<!')) {
                data = JSON.parse(phpText);
              }
            }
          } else {
            // Valid JSON
            data = JSON.parse(text);
          }
        } else {
          // JSON doesn't exist, try PHP (for production server)
          response = await fetch('/Home/images.php');
          if (response.ok) {
            const text = await response.text();
            // Check if PHP was executed (should be JSON) or raw PHP code
            if (!text.trim().startsWith('<?php') && !text.trim().startsWith('<!')) {
              data = JSON.parse(text);
            }
          }
        }
        
        if (data && data.images && data.images.length > 0) {
          // Ensure all image paths are properly formatted
          const processedImages = data.images.map(imagePath => {
            // Remove any leading/trailing whitespace
            let path = imagePath.trim();
            // Ensure path starts with /
            if (!path.startsWith('/')) {
              path = '/' + path;
            }
            return path;
          }).filter(path => path.length > 0);
          
          setImages(processedImages);
          setTexts(data.texts || []);
        } else {
          setImages([]);
          setTexts([]);
        }
        setLoading(false);
      } catch (error) {
        console.error('Error loading images:', error);
        setLoading(false);
        setImages([]);
        setTexts([]);
      }
    };

    fetchImages();
  }, []);

  useEffect(() => {
    if (images.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [images.length]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  if (loading) {
    return <div className="carousel-loading">Loading images...</div>;
  }

  if (images.length === 0) {
    return <div className="carousel-loading">No images found. Please add images to /public/Home/ folder.</div>;
  }

  return (
    <div className="carousel">
      <button
        className="carousel-button prev"
        onClick={prevSlide}
        aria-label="Previous slide"
      >
        ❮
      </button>
      <div className="carousel-container">
        <div
          className="carousel-slides"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {images.map((image, index) => {
            // URL encode the image path to handle spaces and special characters
            // encodeURI handles spaces, parentheses, and other special characters
            const encodedImage = encodeURI(image);
            return (
            <div
              key={index}
              className="carousel-slide"
                style={{ backgroundImage: `url("${encodedImage}")` }}
            >
              <div className="overlay"></div>
                {texts[index] && (
              <div className="text-container">
                <h2 className={`typewriter ${currentIndex === index ? 'animate' : ''}`}>
                  {texts[index]}
                </h2>
              </div>
                )}
            </div>
            );
          })}
        </div>
        <div className="carousel-counter">
          {currentIndex + 1}/{images.length}
        </div>
      </div>
      <button
        className="carousel-button next"
        onClick={nextSlide}
        aria-label="Next slide"
      >
        ❯
      </button>
    </div>
  );
};

export default ImageCarousel;
